<!-- eslint-disable -->
<template>
  <CommonPages id="auto-lease-calculator" :class="['auto-lease-calculator']"
    :titlePrefix="'Auto Lease Calculator'"
    :metaDescription="domainConfig?.['meta']?.des || 'Default des'">
    <div class="auto-lease-calculator-container">
      <!-- 顶部Banner部分 -->
      <div class="calculator-banner"
        :class="[deviceType === 'mobile' ? 'detect_deviece_mobile' : 'detect_deviece_pc']">
        <div class="calculator-banner__content">
          <div class="calculator-banner__title">Auto Lease Calculator</div>
          <div class="calculator-banner__description">
            Discover the perfect lease plan with our Auto Lease Calculator. By entering details such
            as the vehicle's price, lease term, interest rate, and residual value, you can quickly
            determine your monthly lease payments. This tool helps you compare options and find the
            lease that best suits your budget and lifestyle. Start planning your next vehicle lease
            with ease!
          </div>
          <div class="card-button white-button" @click="navigateToPage('/lenders-for-bad-credits')">
            <div class="button-text">View More</div>
            <svg class="button-arrow" viewBox="0 0 16 12" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.5303 6.53033C15.8232 6.23744 15.8232 5.76256 15.5303 5.46967L10.7574 0.696699C10.4645 0.403806 9.98959 0.403806 9.6967 0.696699C9.40381 0.989593 9.40381 1.46447 9.6967 1.75736L13.9393 6L9.6967 10.2426C9.40381 10.5355 9.40381 11.0104 9.6967 11.3033C9.98959 11.5962 10.4645 11.5962 10.7574 11.3033L15.5303 6.53033ZM0 6.75H15V5.25H0V6.75Z"
                fill="#1A4048" />
            </svg>
          </div>
        </div>

        <div class="calculator-banner__image">
          <img src="@/assets/auto-lease-calculator-banner.png" alt="Car Image" />
        </div>
      </div>

      <AdComponent v-if="deviceType == 'mobile'"
        v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.cal_1" ref="ads-cal-1"
        class="ad-width-100 " :ads="adsensConfig?.cal_1" :showDebug="showDebug" />

      <!-- 计算器部分 -->
      <div class="calculator-container"
        :class="[deviceType === 'mobile' ? 'detect_deviece_mobile' : 'detect_deviece_pc']">
        <div class="calculator-flex">
          <!-- 左侧输入表单 -->
          <div class="loan-details">
            <div class="loan-details__header">Loan Details</div>
            <el-form ref="loanForm" :model="loanForm" label-position="top">
              <el-form-item label="Price of vehicle">
                <div class="input-with-icon">
                  <el-input v-model="loanForm.vehiclePrice" placeholder="$30,000" type="text"
                    @input="validateInput('vehiclePrice')"></el-input>
                </div>
              </el-form-item>

              <el-form-item label="Down payment">
                <div class="input-with-icon">
                  <el-input v-model="loanForm.downPayment" placeholder="$1,000" type="text"
                    @input="validateInput('downPayment')"></el-input>
                </div>
              </el-form-item>

              <el-form-item label="Usage tax (Sales tax)">
                <div class="input-with-suffix">
                  <el-input v-model="loanForm.interestRate" placeholder="7" type="text"
                    @input="validateInput('interestRate')"></el-input>
                  <div class="input-suffix">%</div>
                </div>
              </el-form-item>

              <el-form-item label="Length of lease (months)">
                <div class="custom-select-wrapper">
                  <el-select v-model="loanForm.loanTerm" placeholder="24 months">
                    <el-option v-for="item in termOptions" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <div class="select-arrow">
                    <i class="el-icon-arrow-down"></i>
                  </div>
                </div>
              </el-form-item>

              <el-form-item label="New car lending rate">
                <div class="input-with-suffix">
                  <el-input v-model="loanForm.lendingRate" placeholder="4.5" type="text"
                    @input="validateInput('lendingRate')"></el-input>
                  <div class="input-suffix">%</div>
                </div>
              </el-form-item>

              <el-form-item label="Car value at end of loan">
                <div class="input-with-icon">
                  <el-input v-model="loanForm.carValue" placeholder="$12,500" type="text"
                    @input="validateInput('carValue')"></el-input>
                </div>
              </el-form-item>

              <el-form-item class="calculate-btn-wrapper">
                <el-button type="primary" class="calculate-btn"
                  @click="calculateLoan">Calculate</el-button>
              </el-form-item>
            </el-form>
          </div>

          <AdComponent v-if="deviceType == 'mobile'"
            v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.cal_2" ref="ads-cal-2"
            class="ad-width-100 " :ads="adsensConfig?.cal_2" :showDebug="showDebug" />

          <!-- 右侧结果展示 -->
          <div class="loan-estimate">
            <div class="loan-estimate__header">Your Loan Estimate</div>
            <div class="loan-estimate__content">
              <div class="monthly-payment">
                <div class="monthly-payment__label">Total Monthly Payment</div>
                <div class="monthly-payment__value" :class="{'has-value': isResultVisible}">
                  {{ isResultVisible ? calculationResults.monthlyPayment : 'N/A' }}
                </div>
              </div>

              <div class="result-details">
                <div class="divider"></div>
                <div class="result-row">
                  <div class="result-label">Depreciation Fee</div>
                  <div class="result-value" :class="{'has-value': isResultVisible}">
                    {{ isResultVisible ? calculationResults.depreciationFee : 'N/A' }}
                  </div>
                </div>

                <div class="divider"></div>
                <div class="result-row">
                  <div class="result-label">Lease Fee</div>
                  <div class="result-value" :class="{'has-value': isResultVisible}">
                    {{ isResultVisible ? calculationResults.leaseFee : 'N/A' }}
                  </div>
                </div>

                <div class="divider"></div>
                <div class="result-row">
                  <div class="result-label">Pre-Tax Monthly Payment</div>
                  <div class="result-value" :class="{'has-value': isResultVisible}">
                    {{ isResultVisible ? calculationResults.preTaxMonthlyPayment : 'N/A' }}
                  </div>
                </div>

                <div class="divider"></div>
                <div class="result-row">
                  <div class="result-label">Monthly Usage Tax</div>
                  <div class="result-value" :class="{'has-value': isResultVisible}">
                    {{ isResultVisible ? calculationResults.monthlyUsageTax : 'N/A' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AdComponent v-if="deviceType != 'mobile'"
        v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.cal_1" ref="ads-cal-1"
        class="ad-width-100 pc_padding" :ads="adsensConfig?.cal_1" :showDebug="showDebug" />

      <AdComponent v-if="deviceType == 'mobile'"
        v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.cal_3" ref="ads-cal-3"
        class="ad-width-100 " :ads="adsensConfig?.cal_3" :showDebug="showDebug" />

      <!-- 术语表部分 -->
      <div class="glossary-section"
        :class="[deviceType === 'mobile' ? 'detect_deviece_mobile' : 'detect_deviece_pc']">
        <div class="glossary-container">
          <div class="section-header">
            <div class="section-title">Glossary of Terms</div>
            <div class="section-divider"></div>
          </div>

          <div class="glossary-items">
            <div class="glossary-item">
              <img src="@/assets/icons/monthly-payment-icon.svg" class="glossary-icon" alt="" />
              <div class="glossary-content">
                <div class="glossary-term">Total Monthly Payment</div>
                <div class="glossary-description">
                  The total amount you pay each month for the lease, including depreciation, lease
                  fee, and taxes.<br>
                  Calculation: Add the depreciation fee, lease fee, and monthly usage tax to get the
                  total monthly payment.
                </div>
              </div>
            </div>

            <div class="glossary-item">
              <img src="@/assets/icons/depreciation-fee-icon.svg" class="glossary-icon" alt="" />
              <div class="glossary-content">
                <div class="glossary-term">Depreciation Fee</div>
                <div class="glossary-description">
                  The portion of the monthly payment that covers the loss in value of the car over
                  the lease term.
                  <br>Calculation:<br>
                  Subtract the car value at the end of the loan from the price of the vehicle to
                  find the total depreciation.<br>
                  Divide this amount by the length of the lease (in months) to get the monthly
                  depreciation fee.
                </div>
              </div>
            </div>

            <div class="glossary-item">
              <img src="@/assets/icons/lease-fee-icon.svg" class="glossary-icon" alt="" />
              <div class="glossary-content">
                <div class="glossary-term">Lease Fee</div>
                <div class="glossary-description">
                  The cost associated with leasing the car, often including interest and other
                  charges.
                  <br>Calculation:<br>
                  Calculate the average of the vehicle price and the car value at the end of the
                  loan.<br>
                  Multiply this average by the new car lending rate (expressed as a monthly rate) to
                  determine the monthly lease fee.
                </div>
              </div>
            </div>

            <div class="glossary-item">
              <img src="@/assets/icons/pre-tax-monthly-payment-icon.svg" class="glossary-icon"
                alt="" />
              <div class="glossary-content">
                <div class="glossary-term">Pre-tax Monthly Payment</div>
                <div class="glossary-description">
                  The monthly payment amount before sales tax is added.<br>
                  Calculation: Add the depreciation fee and lease fee to get the pre-tax monthly
                  payment.
                </div>
              </div>
            </div>

            <div class="glossary-item">
              <img src="@/assets/icons/monthly-usage-tax-icon.svg" class="glossary-icon" alt="" />
              <div class="glossary-content">
                <div class="glossary-term">Monthly Usage Tax</div>
                <div class="glossary-description">
                  The sales tax applied to the monthly lease payment.<br>
                  Calculation: Multiply the pre-tax monthly payment by the usage tax rate to find
                  the monthly usage tax.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 更多计算器部分 -->
      <div class="more-calculators-section"
        :class="[deviceType === 'mobile' ? 'detect_deviece_mobile' : 'detect_deviece_pc']">
        <div class="more-calculators-container">
          <div class="section-header">
            <div class="section-title">More Calculators</div>
            <div class="section-divider"></div>
          </div>

          <div class="calculators-cards">
            <!-- 汽车租赁计算器卡片 -->
            <div class="calculator-card lease-calculator">
              <div class="calculator-card-image-placeholder" v-if="deviceType != 'mobile'">
                <img src="@/assets/More-3.png" alt="">
              </div>
              <div class="calculator-card-content">
                <div class="calculator-card-title">Auto Loan calculator</div>
                <div class="calculator-card-image-placeholder" v-if="deviceType == 'mobile'">
                  <img src="@/assets/More-3.png" alt="">
                </div>
                <div class="calculator-card-button"
                  @click="navigateToPage('/auto-loan-calculator')">
                  <div class="button-text">Try it</div>
                  <svg xmlns="http://www.w3.org/2000/svg" class="button-icon" viewBox="0 0 16 12"
                    fill="none">
                    <path
                      d="M9.68066 0C9.83345 8.52298e-05 9.97979 0.0601591 10.0879 0.166707L16 6.00048L10.0879 11.8333C9.97979 11.9398 9.83345 11.9999 9.68066 12C9.52776 12 9.38064 11.9399 9.27246 11.8333L8.45703 11.0287C8.40356 10.976 8.36101 10.9135 8.33203 10.8446C8.30301 10.7756 8.2881 10.7016 8.28809 10.6268C8.28809 10.5521 8.30302 10.4781 8.33203 10.4091C8.36106 10.34 8.40341 10.2768 8.45703 10.224L11.583 7.14045H0.578125C0.424844 7.14045 0.277331 7.08069 0.168945 6.97374C0.0606338 6.8668 0 6.72118 0 6.56998V5.43002C0 5.27877 0.0605622 5.13321 0.168945 5.02626C0.277331 4.91931 0.424844 4.85955 0.578125 4.85955H11.582L8.45703 1.77596C8.34898 1.66922 8.28809 1.52404 8.28809 1.37316C8.28817 1.22248 8.34915 1.07799 8.45703 0.971332L9.27246 0.166707C9.38064 0.0600831 9.52776 0 9.68066 0Z"
                      fill="#1A4048" />
                  </svg>
                </div>
              </div>
            </div>

            <!-- 汽车总成本计算器卡片 -->
            <div class="calculator-card cost-calculator">
              <div class="calculator-card-image-placeholder" v-if="deviceType != 'mobile'">
                <img src="@/assets/More-4.png" alt="">
              </div>
              <div class="calculator-card-content">
                <div class="calculator-card-title">Total car cost calculator</div>
                <div class="calculator-card-image-placeholder" v-if="deviceType == 'mobile'">
                  <img src="@/assets/More-4.png" alt="">
                </div>
                <div class="calculator-card-button"
                  @click="navigateToPage('/total-car-cost-calculator/')">
                  <div class="button-text">Try it</div>
                  <svg xmlns="http://www.w3.org/2000/svg" class="button-icon" viewBox="0 0 16 12"
                    fill="none">
                    <path
                      d="M9.68066 0C9.83345 8.52298e-05 9.97979 0.0601591 10.0879 0.166707L16 6.00048L10.0879 11.8333C9.97979 11.9398 9.83345 11.9999 9.68066 12C9.52776 12 9.38064 11.9399 9.27246 11.8333L8.45703 11.0287C8.40356 10.976 8.36101 10.9135 8.33203 10.8446C8.30301 10.7756 8.2881 10.7016 8.28809 10.6268C8.28809 10.5521 8.30302 10.4781 8.33203 10.4091C8.36106 10.34 8.40341 10.2768 8.45703 10.224L11.583 7.14045H0.578125C0.424844 7.14045 0.277331 7.08069 0.168945 6.97374C0.0606338 6.8668 0 6.72118 0 6.56998V5.43002C0 5.27877 0.0605622 5.13321 0.168945 5.02626C0.277331 4.91931 0.424844 4.85955 0.578125 4.85955H11.582L8.45703 1.77596C8.34898 1.66922 8.28809 1.52404 8.28809 1.37316C8.28817 1.22248 8.34915 1.07799 8.45703 0.971332L9.27246 0.166707C9.38064 0.0600831 9.52776 0 9.68066 0Z"
                      fill="#1A4048" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import AdComponent from '@/pages/components/AdComponent.vue'

import '@/css/common.scss';

export default {
  name: 'AutoLoanCalculator',
  components: {
    CommonPages,
    AdComponent,
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      loanForm: {
        vehiclePrice: '',
        downPayment: '',
        interestRate: '',
        loanTerm: '',
        lendingRate: '',
        carValue: ''
      },
      termOptions: [
        { value: '12', label: '12 months (1 year)' },
        { value: '24', label: '24 months (2 years)' },
        { value: '36', label: '36 months (3 years)' },
        { value: '48', label: '48 months (4 years)' },
        { value: '60', label: '60 months (5 years)' },
        { value: '72', label: '72 months (6 years)' },
        { value: '84', label: '84 months (7 years)' }
      ],
      calculationResults: {
        monthlyPayment: '$368.47',
        depreciationFee: '$289.58',
        leaseFee: '$78.89',
        preTaxMonthlyPayment: '$322.48',
        monthlyUsageTax: '$45.99'
      },
      isResultVisible: false
    };
  },
  computed: {
    ...mapGetters([
      'adsensConfig',
      'adPosConfig',
      'deviceType',
      'domainConfig',
      'showDebug',
    ]),
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[AutoLoanCalculator] Component activated`);
    }
  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[AutoLoanCalculator] Component mounted`);
    }
    // 设置当前日期
    const now = new Date();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const year = now.getFullYear();
    this.loanForm.startDate = `${month}/${year}`;

  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[AutoLoanCalculator] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[AutoLoanCalculator] Component beforeDestroy`);
    }
  },
  methods: {
    calculateLoan () {
      try {
        // 清理输入值，移除$和,符号
        const cleanVehiclePrice = this.loanForm.vehiclePrice.toString().replace(/[$,]/g, '');
        const cleanDownPayment = this.loanForm.downPayment.toString().replace(/[$,]/g, '');
        const cleanUsageTax = this.loanForm.interestRate.toString().replace(/[%]/g, '');
        const cleanLendingRate = this.loanForm.lendingRate.toString().replace(/[%]/g, '');
        const cleanCarValue = this.loanForm.carValue.toString().replace(/[$,]/g, '');

        // 解析为数字
        const vehiclePrice = parseFloat(cleanVehiclePrice) || 0;
        const downPayment = parseFloat(cleanDownPayment) || 0;
        const usageTax = parseFloat(cleanUsageTax) || 0;
        const lendingRate = parseFloat(cleanLendingRate) || 0;
        const carValue = parseFloat(cleanCarValue) || 0;
        const loanTerm = parseInt(this.loanForm.loanTerm) || 24;

        // 1. 计算折旧费 (Depreciation Fee)
        // 折旧费 = (车辆价格 - 贷款结束时的车辆价值) / 租赁期限
        const totalDepreciation = vehiclePrice - carValue;
        const depreciationFee = totalDepreciation / loanTerm;

        // 2. 计算租赁费 (Lease Fee)
        // 月租赁费 = (车辆价格 + 贷款结束时的车辆价值) / 2 * 月贷款利率
        const monthlyLendingRate = lendingRate / 12 / 100;
        const leaseFee = ((vehiclePrice + carValue) / 2) * monthlyLendingRate;

        // 3. 计算税前月付款 (Pre-Tax Monthly Payment)
        // 税前月付款 = 折旧费 + 租赁费
        const preTaxMonthlyPayment = depreciationFee + leaseFee;

        // 4. 计算月使用税 (Monthly Usage Tax)
        // 月使用税 = 税前月付款 * 使用税率
        const monthlyUsageTax = preTaxMonthlyPayment * (usageTax / 100);

        // 5. 计算总月付款 (Total Monthly Payment)
        // 总月付款 = 税前月付款 + 月使用税
        const monthlyPayment = preTaxMonthlyPayment + monthlyUsageTax;

        // 格式化结果为货币格式
        const formatCurrency = (value) => {
          return '$' + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        };

        // 更新计算结果
        this.calculationResults = {
          monthlyPayment: formatCurrency(monthlyPayment),
          depreciationFee: formatCurrency(depreciationFee),
          leaseFee: formatCurrency(leaseFee),
          preTaxMonthlyPayment: formatCurrency(preTaxMonthlyPayment),
          monthlyUsageTax: formatCurrency(monthlyUsageTax)
        };

        this.isResultVisible = true;
      } catch (error) {
        console.error('计算出错:', error);
        // 如果计算出错，显示默认值
        this.calculationResults = {
          monthlyPayment: '$0.00',
          depreciationFee: '$0.00',
          leaseFee: '$0.00',
          preTaxMonthlyPayment: '$0.00',
          monthlyUsageTax: '$0.00'
        };
      }
    },

    // 导航到其他页面
    navigateToPage (path) {
      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        // 如果有channel参数，使用完整路径
        this.$router.push(`/${this.$route.params.channel}${path}`);
      } else {
        // 如果没有channel参数，直接导航
        this.$router.push(path);
      }
    },

    validateInput (field) {
      // 清理输入值，移除$和,符号
      let cleanValue;
      if (field === 'interestRate' || field === 'lendingRate') {
        cleanValue = this.loanForm[field].toString().replace(/[%]/g, '');
      } else {
        cleanValue = this.loanForm[field].toString().replace(/[$,]/g, '');
      }

      // 检查是否为有效数字
      if (cleanValue !== '') {
        const numValue = parseFloat(cleanValue);

        // 如果输入的数字小于0，则设置为0
        if (numValue < 0 || isNaN(numValue)) {
          this.loanForm[field] = '0';
        } else {
          // 保持原值，但确保格式正确
          if (field === 'vehiclePrice' || field === 'downPayment' || field === 'carValue') {
            // 为金额类型的输入框添加$符号
            this.loanForm[field] = '$' + cleanValue;
          } else {
            this.loanForm[field] = cleanValue;
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" >
.el-select-dropdown__list {
	padding: 10px;
}
.el-form {
	padding-bottom: 0;
}
</style>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.auto-lease-calculator {
	position: relative;
}

.auto-lease-calculator-container {
	padding: rem(36) rem(120);

	.detect_deviece_mobile & {
		padding: rem(16);
	}
}

// 顶部Banner样式
.calculator-banner {
	border-radius: rem(24);
	background: linear-gradient(270deg, #6fe7d1 0%, #19c4a5 100%);
	padding: 0 rem(36);
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: rem(240);
	position: relative;
	margin-bottom: rem(36);

	.card-button {
		background: #ffffff;
		border-radius: rem(100);
		border: rem(1) solid #1a4048;
		padding: rem(12) 0;
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: center;
		width: rem(136);
		height: rem(40);
		cursor: pointer;

		&:hover {
			background: #f5f5f5;
		}
		.button-text {
			color: #1a4048;
			font-size: rem(14);
			line-height: rem(14);
			font-weight: 700;
		}

		.button-arrow {
			width: rem(16);
			height: rem(12);
		}
	}

	&.detect_deviece_mobile {
		flex-direction: column;
		height: auto;
		padding: rem(24) 0 0 0;
		margin-bottom: rem(16);
	}

	&__content {
		display: flex;
		flex-direction: column;
		gap: rem(20);
		align-items: flex-start;
		justify-content: flex-start;
		width: rem(520);
		position: relative;

		.detect_deviece_mobile & {
			width: 100%;
			margin-bottom: rem(20);
			padding: 0 rem(24);
		}
	}

	&__title {
		color: #ffffff;
		font-size: rem(32);
		line-height: rem(32);
		font-weight: 900;
		position: relative;
		align-self: stretch;

		.detect_deviece_mobile & {
			font-size: rem(24);
			line-height: rem(28);
		}
	}

	&__description {
		color: #ffffff;
		font-size: rem(14);
		line-height: rem(20);
		font-weight: 400;
		position: relative;
		align-self: stretch;

		.detect_deviece_mobile & {
			font-size: rem(12);
			line-height: rem(18);
		}
	}

	&__image {
		flex-shrink: 0;
		width: rem(516);
		height: rem(240);
		position: relative;
		overflow: visible;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		.detect_deviece_mobile & {
			width: 100%;
			height: rem(180);
		}
	}
}

// 计算器容器样式
.calculator-container {
	// padding: rem(36) 0;
	margin-bottom: rem(36);
	display: flex;
	flex-direction: column;
	gap: rem(10);
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;

	&.detect_deviece_mobile {
		margin-bottom: rem(16);
	}
}

.calculator-flex {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: space-between;
	width: 100%;
	position: relative;
	gap: rem(30);
	align-items: stretch;
	align-content: stretch;

	.detect_deviece_mobile & {
		flex-direction: column;
		gap: rem(20);
	}
}

// 贷款详情样式（左侧）
.loan-details {
	background: var(--theme-primary-light);
	border-radius: rem(24);
	padding: 0 rem(36);
	display: flex;
	flex-direction: column;
	gap: rem(2);
	align-items: flex-start;
	justify-content: flex-start;
	width: rem(380);
	position: relative;

	.detect_deviece_mobile & {
		width: 100%;
		padding: 0 rem(16);
	}

	&__header {
		padding: rem(24) 0;
		color: #1a4048;
		text-align: left;
		font-size: rem(20);
		line-height: rem(20);
		font-weight: 700;
		position: relative;
		width: 100%;
	}
}

// 贷款估算样式（右侧）
.loan-estimate {
	background: #ffffff;
	border-radius: rem(24);
	border: rem(1) solid #e5e7eb;
	padding: 0 rem(36);
	display: flex;
	flex-direction: column;
	gap: rem(6);
	align-items: flex-start;
	justify-content: flex-start;
	flex: 1;
	position: relative;

	.detect_deviece_mobile & {
		width: 100%;
		height: auto;
		padding: 0 rem(20);
		min-height: rem(400);
	}

	&__header {
		padding: rem(24) 0;
		color: #1a4048;
		text-align: left;
		font-size: rem(20);
		line-height: rem(20);
		font-weight: 700;
		position: relative;
		width: 100%;
	}

	&__content {
		display: flex;
		flex-direction: column;
		width: 100%;
		flex: 1;
	}
}

// 月付款样式
.monthly-payment {
	display: flex;
	flex-direction: column;
	gap: rem(16);
	align-items: flex-start;
	justify-content: flex-start;
	width: 100%;
	margin-bottom: rem(36);

	&__label {
		color: #1a4048;
		font-size: rem(18);
		line-height: rem(18);
		font-weight: 400;
		width: 100%;
	}

	&__value {
		color: #1a4048;
		font-size: rem(56);
		line-height: rem(56);
		font-weight: 900;
		opacity: 0.1;

		&.has-value {
			opacity: 1;
		}
	}
}

// 结果详情样式
.result-details {
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: rem(36);
	justify-content: space-around;
	flex: 1;
	padding-bottom: rem(36);
}

.divider {
	border-style: dashed;
	border-color: rgba(26, 64, 72, 0.3);
	border-width: rem(1);
	width: 100%;
	height: rem(1);
}

.result-row {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
}

.result-label {
	color: #1a4048;
	font-size: rem(18);
	line-height: rem(20);
	font-weight: 400;
}

.result-value {
	color: #1a4048;
	font-size: rem(24);
	line-height: rem(24);
	font-weight: 700;
	opacity: 0.1;

	&.has-value {
		opacity: 1;
	}
}

// 表单样式
.el-form {
	width: 100%;
	padding-bottom: rem(10);
}

.el-form-item {
	margin-bottom: rem(20);
	width: 100%;
	display: flex;
	flex-direction: column;
}

:deep(.el-form-item__label) {
	color: #1a4048;
	font-size: rem(14);
	line-height: rem(14);
	font-weight: 400;
	padding-bottom: rem(8);
}

:deep(.el-input__inner),
:deep(.el-select .el-input__inner),
:deep(.el-date-editor.el-input .el-input__inner) {
	background: #ffffff;
	border-radius: rem(8);
	border: rem(1) solid #1a4048;
	height: rem(48);
	font-size: rem(18);
	line-height: rem(18);
	color: #1a4048;
	font-weight: 500;
	padding: rem(13) rem(20);
	box-shadow: none;
	width: 100%;
}

.input-with-suffix,
.input-with-icon {
	position: relative;
	width: 100%;
}

.input-suffix {
	position: absolute;
	right: rem(20);
	top: 50%;
	transform: translateY(-50%);
	color: #1a4048;
	font-size: rem(18);
	font-weight: 500;
	pointer-events: none;
	z-index: 1;
}

.input-icon {
	position: absolute;
	right: rem(20);
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	width: rem(20);
	height: rem(20);
	z-index: 1;
}

.icon-placeholder {
	width: rem(20);
	height: rem(20);
	background-color: #1a4048;
	opacity: 0.2;
	border-radius: 50%;
}

.custom-select-wrapper,
.custom-date-wrapper {
	position: relative;
	width: 100%;
}
.el-select-dropdown__list {
	padding: rem(6) !important;
}

:deep(.el-select-dropdown__list) {
	padding: rem(6) !important;
}
.select-arrow,
.date-arrow,
.date-icon,
.select-icon {
	position: absolute;
	right: rem(20);
	top: 50%;
	transform: translateY(-50%);
	color: #1a4048;
	font-size: rem(18);
	pointer-events: none;
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: center;
}

:deep(.el-select),
:deep(.el-date-editor.el-input) {
	width: 100%;
	display: block;
}

:deep(.el-select .el-input__suffix),
:deep(.el-date-editor .el-input__suffix) {
	display: none;
}

:deep(.el-date-editor .el-input__prefix) {
	display: none;
}

:deep(.el-date-editor) {
	padding: 0;
}

.calculate-btn-wrapper {
	padding: rem(24) 0;
	margin-bottom: 0;
}

.calculate-btn {
	background: var(--theme-primary);
	border-radius: rem(100);
	border: none;
	padding: rem(12) rem(32);
	color: #ffffff;
	font-size: rem(20);
	line-height: rem(20);
	font-weight: 700;
	width: 100%;
	height: rem(48);
}

:deep(.el-button:focus),
:deep(.el-button:hover) {
	color: #ffffff;
	border-color: transparent;
	background-color: var(--theme-primary);
	opacity: 0.9;
}

:deep(.el-select-dropdown__item) {
	color: #1a4048;
	font-size: rem(16);
}

:deep(.el-select-dropdown__item.selected) {
	color: var(--theme-primary);
	font-weight: 700;
}

:deep(.el-input.is-focus .el-input__inner) {
	border-color: var(--theme-primary);
}

:deep(.el-date-table td.current:not(.disabled)) {
	color: var(--theme-primary);
}

:deep(.el-form-item) {
	margin-bottom: rem(20);
}

:deep(.el-form-item__content) {
	line-height: normal;
}

:deep(.el-form-item__label) {
	line-height: rem(14);
	height: auto;
	padding-bottom: rem(8);
}

:deep(.el-form-item:last-child) {
	margin-bottom: 0;
}

// 移动端表单样式优化
.detect_deviece_mobile {
	:deep(.el-form-item) {
		margin-bottom: rem(16);
	}

	:deep(.el-input__inner),
	:deep(.el-select .el-input__inner),
	:deep(.el-date-editor.el-input .el-input__inner) {
		font-size: rem(16);
	}

	.calculate-btn {
		font-size: rem(18);
	}
}

// 术语表部分样式
.glossary-section {
	// padding: rem(36) 0;
	margin-bottom: rem(36);
	width: 100%;

	.detect_deviece_mobile & {
		padding: 0;
		margin-bottom: 0;
	}
}

.glossary-container {
	background: linear-gradient(180deg, var(--theme-primary-light) 0%, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0) 100%);
	border-radius: rem(24);
	padding: 0 rem(36) rem(36);
	width: 100%;

	.detect_deviece_mobile & {
		padding: 0 rem(16);
	}
}

.section-header {
	padding: rem(24) 0;
	display: flex;
	flex-direction: column;
	gap: rem(20);
	align-items: flex-start;
	justify-content: center;
	height: rem(96);

	.detect_deviece_mobile & {
		height: auto;
		padding: rem(20) 0;
	}
}

.section-title {
	color: #1a4048;
	font-size: rem(24);
	line-height: rem(24);
	font-weight: 900;
	text-align: left;

	.detect_deviece_mobile & {
		font-size: rem(20);
		line-height: rem(20);
	}
}

.section-divider {
	background: var(--theme-primary);
	border-radius: rem(100);
	width: rem(36);
	height: rem(4);
}

.glossary-items {
	display: flex;
	flex-direction: column;
	gap: rem(24);
	padding-bottom: rem(36);
}

.glossary-item {
	display: flex;
	flex-direction: row;
	gap: rem(24);
	align-items: flex-start;
	width: 100%;

	.detect_deviece_mobile & {
		// flex-direction: row;
		// gap: rem(12);
	}
}

.glossary-icon {
	flex-shrink: 0;
	width: rem(32);
	height: rem(32);

	.detect_deviece_mobile & {
		width: rem(24);
		height: rem(24);
	}
}

.glossary-content {
	display: flex;
	flex-direction: column;
	gap: rem(8);
	flex: 1;
}

.glossary-term {
	color: #1a4048;
	font-size: rem(14);
	line-height: rem(14);
	font-weight: 900;
}

.glossary-description {
	color: #1a4048;
	font-size: rem(12);
	line-height: rem(16);
	font-weight: 400;
}

// 更多计算器部分样式
.more-calculators-section {
	// padding: rem(36) 0 rem(72);
	margin-bottom: rem(72);
	width: 100%;

	.detect_deviece_mobile & {
		margin-bottom: rem(36);
		// padding: rem(20) 0 rem(40);
	}
}

.more-calculators-container {
	background: linear-gradient(180deg, var(--theme-primary-light) 0%, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0) 100%);
	border-radius: rem(24);
	padding: 0 rem(36);
	width: 100%;

	.detect_deviece_mobile & {
		padding: 0;
		.section-header {
			padding: rem(24) rem(16);
		}
	}
}

.calculators-cards {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	padding-bottom: rem(36);

	.detect_deviece_mobile & {
		flex-direction: column;
		gap: rem(36);
		padding-bottom: 0;
	}
}

.calculator-card {
	border-radius: rem(20);
	padding: rem(20);
	display: flex;
	flex-direction: row;
	gap: rem(20);
	align-items: flex-start;
	width: 48%;

	.detect_deviece_mobile & {
		width: 100%;
		flex-direction: column;
		padding: rem(20) rem(19) 0;
	}
}

.lease-calculator {
	background: linear-gradient(180deg, rgba(25, 196, 165, 1) 0%, rgba(111, 231, 209, 1) 100%);
}

.cost-calculator {
	background: linear-gradient(180deg, rgba(218, 161, 13, 1) 0%, rgba(246, 195, 63, 1) 100%);
}

.calculator-card-image-placeholder {
	flex-shrink: 0;
	width: rem(300);
	height: rem(160);

	.detect_deviece_mobile & {
		width: 100%;
		height: rem(180);
	}
}

.calculator-card-content {
	padding: rem(12) 0 rem(8);
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: space-between;
	flex: 1;
	height: rem(160);

	.detect_deviece_mobile & {
		padding-top: 0;
		align-items: center;
	}
}

.calculator-card-title {
	color: #ffffff;
	font-size: rem(28);
	line-height: rem(28);
	font-weight: 900;

	.detect_deviece_mobile & {
		font-size: rem(24);
		line-height: rem(24);
		text-transform: capitalize;
		margin-bottom: rem(16);
	}
}

.calculator-card-button {
	background: #ffffff;
	border-radius: rem(100);
	border: rem(1) solid #1a4048;
	padding: rem(12) rem(32);
	display: flex;
	flex-direction: row;
	gap: rem(12);
	align-items: center;
	justify-content: center;
	width: rem(136);
	height: rem(40);
	cursor: pointer;

	&:hover {
		background: #f5f5f5;
	}

	.detect_deviece_mobile & {
		display: flex;
		width: rem(136);
		height: rem(40);
		padding: rem(12) rem(32);
		margin-bottom: rem(-20);
	}
}

.button-text {
	color: #1a4048;
	font-size: rem(16);
	line-height: rem(16);
	font-weight: 700;
}

.button-icon {
	width: rem(16);
	height: rem(12);
}
</style> 